import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserInformationThunk, loginThunk } from "./userThunks";
import { ITokenResponseData, IUserDetailResponseData } from "./userTypes";
import { setAuthToken } from "../../../utils/functions/setAuthToken";
import { addSecondsToCurrentTime } from "../../../utils/functions/addSecondsToCurrentTime";
import { secondsToMileSeconds } from "../../../utils/functions/secondsToMileSeconds";

export interface initialUserState {
  isAuthenticated: boolean;
  token: ITokenResponseData;
  user: IUserDetailResponseData;
}

const tokenDefaultValue = {
  token: "",
  refreshToken: "",
  refreshTokenExpiresIn: 0,
  tokenExpiresIn: 0,
};

const initialState: initialUserState = {
  isAuthenticated: false,
  token: tokenDefaultValue,
  user: { id: 0, userName: "" },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login(state: initialUserState) {
      state.isAuthenticated = true;
    },
    logout(state: initialUserState) {
      state.isAuthenticated = false;
      state.token = tokenDefaultValue;

      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(
        loginThunk.fulfilled,
        (
          state: initialUserState,
          action: PayloadAction<ITokenResponseData>
        ) => {
          const { token, tokenExpiresIn, refreshToken, refreshTokenExpiresIn } =
            action.payload;
          state.isAuthenticated = true;
          state.token = { ...action.payload };

          if (action.payload) {
            const tokenLife = tokenExpiresIn - 30;

            const refreshTokenLife = refreshTokenExpiresIn;
            const currentTime = addSecondsToCurrentTime(0);
            const tokenLifeTime = addSecondsToCurrentTime(
              secondsToMileSeconds(tokenLife)
            );
            const refreshTokenLifeTime = addSecondsToCurrentTime(
              secondsToMileSeconds(refreshTokenLife)
            );

            const data = {
              token,
              refreshToken,
              currentTime,
              tokenLifeTime,
              refreshTokenLifeTime,
            };

            setAuthToken(JSON.stringify(data));
          }
        }
      )
      .addCase(
        getUserInformationThunk.fulfilled,
        (
          state: initialUserState,
          action: PayloadAction<IUserDetailResponseData>
        ) => {
          state.user = action.payload;
        }
      ),
});

export const { login, logout } = userSlice.actions;
export const useReducer = userSlice.reducer;
